<template>
  <div class="header">
    <div
      v-if="$store.state.existsGroup"
      class="toggle-show-menu material-icons"
      @click="$store.commit('setToggleShowMenu')">menu</div>
    <div class="title">日報管理アプリβ</div>
    <div class="view">
      <button
        :class="['view-content', {thisview: $route.path === '/month' || $route.path === '/'}]"
        @click="$emit('setView', '/month', $store.state.thisDate, null)">月</button>
      <button
        :class="['view-content', {thisview: $route.path === '/day'}]"
        @click="$emit('setView', '/day', $store.state.today, null)">日</button>
      <button
        :class="['view-content', {thisview: $route.path === '/user'}]"
        @click="$emit('setView', '/user', $store.state.today, $store.state.existsGroup ? $store.state.selectedUserId : $store.state.currentUser.id)">人</button>
    </div>
    <div class="date">
      <button
        class="date-content"
        @click="setPage('prev')">
        <i class="material-icons-outlined">keyboard_arrow_left</i>
      </button>
      <button
        class="date-content"
        @click="setPage('this')">
        <span class="no-icon">{{ thisViewName }}</span>
      </button>
      <button
        class="date-content"
        @click="setPage('next')">
        <i class="material-icons-outlined">keyboard_arrow_right</i>
      </button>
    </div>
    <div class="tool high-width">
      <button
        class="tool-content refresh"
        title="日報を更新"
        @click="updateDiaries">
        <i class="material-icons-outlined">autorenew</i>
      </button>
      <button
        v-if="workMailUse"
        :title="!workMailAddress ? workStartMessage : ''"
        :disabled="!workMailAddress"
        class="tool-content send-btn"
        @click="sendWorkStartMail">
        <i class="material-icons">send</i>
        <span class="label">業務開始</span>
      </button>
      <button
        :disabled="$store.state.isLoading"
        class="tool-content edit-btn"
        @click="$emit('showForm', $store.state.currentUser.id, $store.state.today.format('YYYY-MM-DD'))">
        <i class="material-icons">edit</i>
        <span class="label">日報作成</span>
      </button>
    </div>
    <!-- 以下menu -->
    <i
      class="material-icons menu-icon"
      @click.stop="isShowMenu = !isShowMenu">more_vert</i>
    <transition>
      <div
        v-if="isShowMenu"
        class="overlay"
        @click="isShowMenu = false">
        <div
          class="drawer-menu-wrapper"
          @click.stop>
          <div
            class="drawer-top">
            <div
              class="item user-item">
              <div class="username-popup">{{ $store.state.currentUser.name.last + $store.state.currentUser.name.first }}</div>
              <span class="material-icons user-icon">person</span>
              <span class="username-text">{{ $store.state.currentUser.name.last + $store.state.currentUser.name.first }}</span>
            </div>
            <i
              class="material-icons close-icon"
              @click="isShowMenu = false">clear</i>
          </div>
          <div class="divider" />
          <div
            class="drawer-menu"
            @click="isShowMenu = false">
            <span class="low-width">
              <div
                class="item"
                @click="sendWorkStartMail"><span class="material-icons">send</span>業務開始の連絡</div>
              <div
                class="item"
                @click="updateDiaries"><span class="material-icons">autorenew</span>日報を更新する</div>
              <div
                class="item"
                @click="$emit('showForm', $store.state.currentUser.id, $store.state.today.format('YYYY-MM-DD'))"><span class="material-icons">edit</span>日報を作成する</div>
              <div class="divider" />
            </span>
            <div
              v-if="$store.state.currentUser.isAdmin"
              class="item"
              @click="openSite('settings')"><span class="material-icons">settings</span>設定</div>
            <div
              class="item"
              @click="openSite('update')"><span class="material-icons">update</span>アップデート履歴</div>
            <div
              class="item"
              @click="reload"><span class="material-icons">rotate_right</span>ページ再読み込み</div>
            <div class="divider" />
            <div
              class="item"
              @click="signOut"><span class="material-icons">exit_to_app</span>サインアウト</div>
          </div>
          <div class="version">Version.{{ $version }}</div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Moment from 'moment'
import firebase from 'firebase/app'
import {db} from '@/plugins/firestore'
import ms from '@/utils/msGraphApi'
import sw from '@/utils/sweetAlert'

export default {
  data () {
    return {
      /**
       * メニューが表示中を判別するフラグ
       * @type {Boolean}
       */
      isShowMenu: false,
      /**
       * 勤怠連絡先メールアドレス
       * @type {String}
       */
      workMailAddress: '',
      /**
       * 勤怠連絡機能を利用するかどうか
       * @type {Boolean}
       */
      workMailUse: true,
      /**
       * 業務開始ボタンが非活性のときのホバーメッセージ
       * @type {String}
       */
      workStartMessage: '勤怠連絡機能を利用する場合は\n勤怠連絡先メールアドレスを設定してください'
    }
  },
  computed: {
    /**
     * [< ○○ >] 日表示なら○○が『今日』それ以外なら『今月』
     * @returns {String} 表示する文字列
     */
    thisViewName () {
      switch (this.$route.path) {
        case '/day': { return this.$store.state.thisDate.isSame(this.$store.state.today, 'day') ? '今日' : '今日へ' }
        default: { return this.$store.state.thisDate.isSame(this.$store.state.today, 'month') ? '今月' : '今月へ' }
      }
    }
  },
  mounted () {
    // 勤怠連絡アドレスを取得
    db.doc(`tenants/${this.$store.state.tenant}`).get().then((doc) => {
      // firestoreにworkMailが設定されていない場合、勤怠連絡ボタンを非活性にして表示したいので
      // workMailUseをtrueにする
      this.workMailUse = doc.data().workMail ? doc.data().workMail.use : true
      this.workMailAddress = doc.data().workMail ? doc.data().workMail.address : ''
    }).catch((error) => {
      sw.toastAlert('error', '取得に失敗しました')
      console.error(`エラー:${error}`)
    })
  },
  methods: {
    /**
     * ページ更新
     */
    reload () {
      this.$swal({
        icon: 'warning',
        text: 'ページを再読み込みします',
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        if (result.isConfirmed) {
          location.reload()
        }
      })
    },
    /**
     * 日報更新
     */
    updateDiaries () {
      this.$store.dispatch('getDiaries')
    },
    /**
     * | < | ○○ | > |のボタンを押した場合にカレンダーの月または日を変更する
     * @param {String} page [○○]はthis,[<]はprev,[>]はnext
     */
    setPage (page) {
      const date = this.$store.state.thisDate
      // もしthisが渡されたなら、現在時刻を格納。それ以外なら先月か翌月を格納
      switch (page) {
        case 'this': {
          this.$store.commit('setThisDate', this.$store.state.today)
          break
        }
        case 'next': {
          if (this.$route.path === '/day') {
            this.$store.commit('setThisDate', Moment(this.$store.state.thisDate).add(1, 'day'))
            break
          }
          this.$store.commit('setThisDate', Moment(this.$store.state.thisDate).add(1, 'month'))
          break
        }
        case 'prev': {
          if (this.$route.path === '/day') {
            this.$store.commit('setThisDate', Moment(this.$store.state.thisDate).add(-1, 'day'))
            break
          }
          this.$store.commit('setThisDate', Moment(this.$store.state.thisDate).add(-1, 'month'))
          break
        }
      }
      // 月遷移したなら日報情報を取得する
      if (!this.$store.state.thisDate.isSame(date, 'month')) {
        this.$store.dispatch('getDiaries')
      }
    },
    /**
     * 出社メールを送信する前に確認アラートを表示
     */
    sendWorkStartMail () {
      this.$swal({
        icon: 'info',
        text: '業務開始メールを送信します',
        showCancelButton: true,
        reverseButtons: true
      }).then((result) => {
        // ユーザーが『OK』ボタンを押したら[sendMail]を呼び出す
        if (result.isConfirmed) {
          // ユーザーが日報アプリを使用している時、他のユーザーが送信先設定を変更した場合に対応するため
          // Firestoreに接続してメールアドレスを取得する
          db.doc(`tenants/${this.$store.state.tenant}`).get().then((doc) => {
            const name = this.$store.state.currentUser.name.last
            const mailContent = {
              message: {
                subject: `勤怠連絡 ${this.$store.state.today.format('MM/DD')} ${name}`,
                body: {
                  contentType: 'Text',
                  content:
                    `宛先各位\n\n` +
                    `お疲れ様です。${name}です。\n\n` +
                    `本日の業務を開始いたします。\n\n` +
                    `よろしくお願いいたします。`
                },
                toRecipients: [{
                  emailAddress: {
                    address: doc.data().workMail.address
                  }
                }]
              }
            }
            ms.sendMail(JSON.stringify(mailContent), 'sendWork')
          }).catch((error) => {
            sw.toastAlert('error', '投稿先の取得に失敗しました')
            console.error(`エラー:${error}`)
          })
        }
      })
    },
    /**
     * サインアウトするメソッド
     */
    signOut () {
      this.$swal({
        icon: 'warning',
        text: 'サインアウトしてもよろしいですか？',
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonColor: '#ff3d0c'
      }).then((result) => {
        // OKボタンを押したら
        if (result.isConfirmed) {
          // firebaseのsignOutメソッドを呼び出しサインアウト
          firebase.auth().signOut().then(() => {
            sessionStorage.setItem('isSignOut', 'true')
            this.$router.push('/signout')
          }).catch((error) => {
            this.$swal({
              icon: 'error',
              text: 'サインアウト時にエラーが発生しました\r\n' + error
            })
          })
        }
      })
    },
    /**
     * お問い合わせフォームに飛ばす
     * @param {String} site 遷移先
     */
    openSite (site) {
      switch (site) {
        case 'settings': {
          window.open(this.$router.resolve({name: 'settings'}).href, '_blank')
          break
        }
        // (未使用)
        case 'form': {
          window.open('https://forms.gle/8JJ4Xx7neKo8XHJh9', '_blank')
          break
        }
        // (未使用)
        case 'list': {
          const url = 'https://psc-cloud-apps.visualstudio.com/20%E6%96%B0%E5%8D%92%E8%AA%B2%E9%A1%8C%E7%94%A8/_queries?tempQueryId=639b2416-9d0c-448b-aee3-caa97eedb903'
          if (localStorage.getItem('header-list') === '1') {
            window.open(url, '_blank')
            break
          }
          this.$swal({
            icon: 'info',
            text: '閲覧できない場合権限を付与しますので近江さんにご連絡ください。',
            input: 'checkbox',
            inputPlaceholder: '次回から表示しない'
          }).then((result) => {
            localStorage.setItem('header-list', result.value)
            window.open(url, '_blank')
          })
          break
        }
        case 'update': {
          window.open(this.$router.resolve({name: 'updatelist'}).href, '_blank')
          break
        }
      }
    }
  }
}
</script>

<style scoped>
.header {
  position: relative;
  user-select: none;
  display: flex;
  background: #fff;
  width: 100%;
  height: 48px;
  min-height: 48px;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, .25);
  z-index: 6;
}
.toggle-show-menu {
  height: 100%;
  margin: 0 0 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.title {
  height: 100%;
  margin: 0 0 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1em;
  font-weight: bold;
}
button {
  display: inline-block;
  height: 100%;
  padding: 8px 12px;
  margin-bottom: 0;
  font-size: 0.9em;
  line-height: 1.428571429;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: 1px solid #e5e5e5;
}
button:focus {
  outline: none;
}
.view {
  height: 100%;
  margin: 0 0 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1em;
  font-weight: bold;
}
.view-content {
  width: 70px;
  height: 48px;
  color: #828282;
  float: left;
  margin-left: -1px;
  background-color: #fff;
  border: 0px;
}
.view-content:hover {
  outline:0;
  color: #333;
  background-color: #f2f2f2;
}
.view .thisview {
  color: #0e7bc6;
  font-weight: bold;
  border-bottom: 3px solid #0e7bc6;
  background: #0e7bc620;
  cursor: default;
}
.date {
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1em;
  font-weight: bold;
}
.date-content {
  width: 70px;
  height: 48px;
  color: #828282;
  float: left;
  margin-left: -2px;
  background-color: #fff;
  border-top: 0px;
  border-bottom: 0px;
}
.date-content:hover {
  outline:0;
  color: #333;
  background-color: #f2f2f2;
}
.tool {
  height: 100%;
  float: right;
  margin: 0 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1em;
  font-weight: bold;
}
.tool-content {
  height: 40px;
  margin: 0 0 0 5px;
  color: #828282;
  background-color: #fff;
  border-radius: 3px;
}
.refresh:hover {
  color: #333;
  background-color: #f2f2f2;
}
.send-btn {
  color: #fff;
  background-color: #0e7bc6;
}
.send-btn:hover {
  background-color: #0e7bc6;
  opacity: 0.9;
}
.send-btn:disabled {
    background-image: none;
    background-color: rgb(163, 163, 163);
    border-color: rgb(163, 163, 163);
}
.edit-btn {
  color: #fff;
  background-color: #cc0000;
}
.edit-btn:hover {
  background-color: #cc0000;
  opacity: 0.8;
}
.tool-content .material-icons {
  font-size: 1.4em;
  color: #fff;
  padding: 0;
}
.tool-content .material-icons-outlined {
  font-size: 1.4em;
  padding: 0;
}
.label {
  line-height: 1;
  vertical-align: middle;
}
.material-icons-outlined {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media screen and (max-width:950px){
  .high-width {
    display: none;
  }
  .date {
    float: right;
    margin: 0 10px 0 auto;
  }
}
@media screen and (max-width:640px){
  .title {
    display: none;
  }
}
@media screen and (min-width:950px){
  .low-width {
    display: none;
  }
}
/* 以下menu */
.menu-icon {
  height: 100%;
  float: right;
  margin: 0 10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.5em;
  color: #333;
}
.close-icon {
  color: #333;
  margin: 3px;
  cursor: pointer;
}
.material-icons {
  color: #828282;
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  display: inline-flex;
  vertical-align: middle;
  cursor: pointer;
}
.divider {
  background: #fff;
  border-bottom: 1px solid #ccc;
}
.overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 500;
  user-select: none;
}
.drawer-menu-wrapper {
  position: fixed;
  top: 45px;
  right: 10px;
  color: #333;
  background-color: #fff;
  box-shadow: 0 10px 25px 0 rgba(0, 0, 0, .5);
  border-radius: 3px;
}
.drawer-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size:0.7em;
}
.user-icon {
  font-size:2em;
}
.username-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width:160px;
}
.user-item:hover .username-popup{
  opacity:1;
  transition-delay: 1s;
  z-index: 2;
}
.username-popup {
  opacity:0;
  position: absolute;
  z-index: 0;
  left: 12%;
  top:100%;
  width: fit-content;
  max-width:100%;
  background: rgb(255, 255, 255);
  overflow-wrap:  break-word;
  border: 1px solid #000;
  padding:5px;
  font-size:1em;
}
.user-item {
  display: flex;
  align-items: center;
  gap:4px;
  margin:0 1px;
  width:100%;
  position: relative;
}
.drawer-menu {
  width: 230px;
  height: 100%;
  position: relative;
  font-size: 0.9em;
}
.item {
  cursor: pointer;
  padding: 6px 5px;
}
.item:hover {
  background: #f2f2f2 !important;
}
.version {
  position: relative;
  left: 160px;
  color: #555;
  font-size: 0.5em;
}
:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

</style>



// WEBPACK FOOTER //
// src/components/modules/DailyReport/Header.vue